<template>
  <div id="layout-footer">
    <div class="footer-main">
      <div class="footer-item">
        <div class="footer-item-title">相关链接</div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.authConfig.github">
            <i class="iconfont icon-github"></i> GitHub
          </a>
        </div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.authConfig.gitee">
            <i class="iconfont icon-gitee"></i> Gitee
          </a>
        </div>
      </div>
      <div class="footer-item footer-center">
        <div class="footer-logo">{{ this.$store.state.webConfig.name }}</div>
        <div class="footer-slogan">一个热爱技术的博主</div>
      </div>
      <div class="footer-item">
        <div><i class="iconfont icon-shijian"></i> 已运行 <em class="run-time">{{ this.$store.state.runTimeInterval }}</em></div>
        <div><i class="el-icon-user"></i> 在线 <em class="online-count">{{ this.$store.state.onlinePerson }}</em> 人</div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.webConfig.managementUrl">☞ 后台管理</a>
        </div>
      </div>
    </div>
    <div class="footer-divider"></div>
    <div class="copyright">
      Copyright &copy; {{ this.$store.state.runTimeYear }}
      <a target="_blank" class="out-link" :href="this.$store.state.webConfig.webUrl">qiangesoft.cn</a>
      All Rights Reserved &nbsp;|
      <a target="_blank" class="out-link" href="https://beian.miit.gov.cn/">{{ this.$store.state.webConfig.recordNum }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout-footer",
  data() {
    return {

    }
  },
  computed: {
  },
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="less">
#layout-footer {
  padding: 45px 0 0;
  color: rgba(255, 255, 255, 0.75);
  background: linear-gradient(135deg, #312e81 0%, #1e1b4b 50%, #111827 100%);
  font-size: 14px;
}

a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.55);
  transition: all 0.25s ease;
}

.out-link:hover {
  color: #a5b4fc;
}

.footer-main {
  max-width: 900px;
  margin: 0 auto 36px auto;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 0 20px;
}

.footer-item-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

.footer-item div {
  margin-top: 12px;
  line-height: 1.9;
}

.footer-center {
  text-align: center;
}

.footer-logo {
  font-size: 22px;
  font-weight: 700;
  background: linear-gradient(135deg, #a5b4fc 0%, #818cf8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;
}

.footer-slogan {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
}

.run-time {
  font-style: normal;
  background: rgba(99, 102, 241, 0.2);
  border: 1px solid rgba(99, 102, 241, 0.35);
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 13px;
  color: #a5b4fc;
  font-weight: 600;
}

.online-count {
  font-style: normal;
  background: rgba(6, 182, 212, 0.2);
  border: 1px solid rgba(6, 182, 212, 0.35);
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 13px;
  color: #22d3ee;
  font-weight: 600;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 0 40px;
}

.copyright {
  text-align: center;
  padding: 18px 20px;
  color: rgba(255, 255, 255, 0.35);
  font-size: 13px;
  line-height: 2;
}

.copyright a {
  color: rgba(255, 255, 255, 0.5);
  margin: 0 4px;
}

.copyright a:hover {
  color: #a5b4fc;
}
</style>
